import {DefaultFoundationTheme, Integer} from 'platform/foundation';
import styled from 'styled-components';

import {Nullish} from 'shared/web';

import {quillThemeOverrides} from './quillTheme';

export type StyledQuillWrapperProps = {
  $isFocused?: boolean;
  $isDisabled?: boolean;
  $isInvalid?: boolean;
  $isResizable?: boolean;
  $isScrollable?: boolean;
  $rows?: Integer;
  $minRows?: Integer | Nullish;
  $maxRows?: Integer | Nullish;
};

export const StyledQuillWrapper = styled.div<StyledQuillWrapperProps>`
  position: relative;

  .ql-container {
    min-height: ${({theme, $rows, $minRows}) =>
      `max(150px, ${getEditorHeight(theme, $minRows ?? $rows ?? 6)})`};
    max-height: ${({theme, $maxRows}) => ($maxRows ? getEditorHeight(theme, $maxRows) : 'none')};
    overflow-y: ${({$isScrollable}) => ($isScrollable ? 'auto' : 'hidden')};

    .ql-editor {
      resize: ${({$isResizable}) => ($isResizable ? 'vertical' : 'none')};
    }
  }

  ${quillThemeOverrides}
`;

function getEditorHeight(theme: DefaultFoundationTheme, rows: Integer) {
  return `calc(${rows} * ${theme.lineHeights.text.small} + ${theme.getSize(4)})`;
}
